import { render, staticRenderFns } from "./LatestPrivacyContract.vue?vue&type=template&id=ff5cf762&scoped=true&"
import script from "./LatestPrivacyContract.vue?vue&type=script&lang=js&"
export * from "./LatestPrivacyContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5cf762",
  null
  
)

export default component.exports